import React from "react";
import BusinessInterestVendorDashboard from "../component/BusinessInterestVendorDashboard";

const BusinessInterestVendorView = () => (
  <div>
    <BusinessInterestVendorDashboard />
  </div>
);

export default BusinessInterestVendorView;
